import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../utils/cn';
const variants = {
    default: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300 ring-1 ring-gray-500/20',
    secondary: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400 ring-1 ring-gray-500/20',
    destructive: 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-400 ring-1 ring-red-600/20',
    outline: 'border border-gray-300 text-gray-700 dark:border-gray-600 dark:text-gray-300 bg-transparent',
    success: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400 ring-1 ring-emerald-600/20',
    warning: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 ring-1 ring-amber-600/20',
    info: 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 ring-1 ring-blue-600/20',
    brand: 'bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400 ring-1 ring-brand-600/20'
};
const sizes = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm'
};
const Badge = React.forwardRef(({ className, variant = 'default', size = 'md', dot, ...props }, ref) => {
    if (dot) {
        return (_jsx("div", { ref: ref, className: cn('w-2 h-2 rounded-full', variants[variant].match(/bg-\S+/)?.[0], className), ...props }));
    }
    return (_jsx("div", { ref: ref, className: cn('inline-flex items-center rounded-full font-semibold tracking-wide transition-colors duration-150', variants[variant], sizes[size], className), ...props }));
});
Badge.displayName = 'Badge';
export { Badge };
